import React from 'react';

import { Button, Hero, Section } from '@cfm-media/pwa-ui-components';
import { parseHtml } from '../core/utils';
import { useTranslation } from '../core/utils/translations';

import { PageWrapper } from '../components/page-wrapper';

export const LimousineService = () => {
  const { t } = useTranslation('limousine-service-page');

  return (
    <PageWrapper>
      <Hero
        image="public/assets/images/teasers/limousine-service.jpg"
        icon="icon-chauffeur"
        headline="Home2Gate - Airporttransfer"
        overlay
      />

      <Section className="!pt-5">
        <div className="pwa-content"> {parseHtml(t('body-text'))}</div>
        <div className="mt-5">
          <LimousineServiceButton />
        </div>
      </Section>
    </PageWrapper>
  );
};

function LimousineServiceButton() {
  const { t } = useTranslation('limousine-service-page');

  return (
    <Button
      className="w-full sm:w-auto rounded-md"
      target="_blank"
      title={t('limousine-service-button-text')}
      variant="primary"
      link={`https://www.cdserver1.com/WebBooking/WebBooking5.aspx?ID=91c25ab2-c787-4213-b89b-5c84464e1ef0`}
    ></Button>
  );
}

export const isLimousineServiceActive = (bookingStore) => {
  return bookingStore?.booking?.data?.flights?.some(
    (flight) => flight.departureAirport.toUpperCase() === 'ZRH',
  );
};
